module.exports = __webpack_public_path__ + "static/media/heatmap_tuto_overlap.cce52966.gif";